import React, { Fragment } from 'react';
import DocumentView from "components/sales/downloadDocView/documentView";


const RepliesOnTicket= ({repliesData = []}) => (
    <Fragment>
        { repliesData.length > 0 && repliesData.map((item, index) => (
        
            <div key={index} className="details-listing reply-box">
                <div className="details-byline">
                    <div className="details-list">
                        <strong className="data-title">Reply Date </strong>
                        <span className="data-details">{item.created_at.slice(0, 10)}</span>
                    </div>
                    <div className="details-list">
                        <strong className="data-title d-none d-md-block">Replied by</strong>
                        <span className="data-details"><span className="d-md-none">By </span>{item.replied_by}</span>
                    </div>
                </div>
                <div className="details-list full-width">
                    <strong className="data-title">Response</strong>
                    <span className="data-details">{item.response}</span>
                </div>
                {item.document && <DocumentView attachment={item.document} />}
            </div>
        ))}
    </Fragment>
);

export default RepliesOnTicket;
